import mapValuesToRequestConfiguration from './mappers/mapValuesToRequestConfiguration'

export default function(api: GlobalFetch) {
  return async function(values, objectId: string, calendarId: string) {
    const requestBody = mapValuesToRequestConfiguration(
      values,
      objectId,
      calendarId,
    )
    const response = await api.fetch(
      `/api/v2/price/settings/id_calendar/${calendarId}/id_object/${objectId}/`,
      {
        body: JSON.stringify(requestBody),
        method: 'POST',
      },
    )
    if (response.ok) {
      return response.status.toString()
    } else {
      throw new Error(response.status.toString())
    }
  }
}
